import { Icon } from '@chakra-ui/react';

const PCTestimonialIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<path class="st0" d="M29.2,15.78c-0.09,0.49-0.16,0.98-0.27,1.46c-0.5,2.14-1.6,3.91-3.29,5.32c-1.05,0.88-2.23,1.51-3.54,1.88
		c-0.22,0.06-0.28,0.16-0.28,0.38c0.01,1.23,0,2.46,0.01,3.69c0,0.28-0.06,0.52-0.34,0.64c-0.29,0.13-0.52,0-0.72-0.2
		c-1.31-1.31-2.61-2.62-3.93-3.92c-0.1-0.1-0.28-0.18-0.43-0.18c-1.81-0.01-3.62-0.01-5.44-0.01c-1.34,0-2.65-0.19-3.9-0.69
		c-1.95-0.77-3.51-2.03-4.66-3.78c-1.16-1.76-1.69-3.7-1.61-5.8c0.05-1.53,0.46-2.97,1.19-4.31c0.18-0.34,0.5-0.45,0.78-0.3
		c0.29,0.15,0.38,0.47,0.2,0.81C2.48,11.72,2.15,12.71,2,13.76c-0.23,1.64-0.01,3.22,0.66,4.73c0.92,2.06,2.42,3.55,4.48,4.48
		c1.17,0.53,2.4,0.75,3.69,0.74c1.94-0.01,3.88,0,5.83-0.01c0.33,0,0.58,0.1,0.81,0.33c0.99,1,1.99,1.99,2.98,2.99
		c0.07,0.07,0.12,0.17,0.18,0.25c0.03-0.02,0.05-0.03,0.08-0.05c0.01-0.08,0.02-0.15,0.02-0.23c0-0.92,0-1.83,0-2.75
		c0-0.49,0.12-0.65,0.61-0.76c1.12-0.26,2.15-0.71,3.08-1.39c2-1.47,3.23-3.42,3.58-5.89c0.36-2.51-0.27-4.77-1.86-6.73
		c-1.41-1.75-3.25-2.82-5.49-3.13c-0.62-0.09-1.25-0.08-1.88-0.11c-0.4-0.02-0.64-0.2-0.66-0.53c-0.02-0.32,0.18-0.57,0.5-0.58
		c1.63-0.08,3.2,0.15,4.7,0.82c2.01,0.9,3.57,2.32,4.65,4.23c0.66,1.17,1.05,2.43,1.2,3.77c0.01,0.11,0.04,0.22,0.05,0.32
		C29.2,14.78,29.2,15.28,29.2,15.78z"/>
			<path class="st0" d="M13.5,0.8c0.31,0.16,0.41,0.41,0.4,0.75c-0.02,0.47,0,0.94-0.01,1.41c0,0.33-0.16,0.53-0.46,0.6
		c-0.75,0.18-0.96,0.41-1.07,1.2c0.28,0,0.55,0,0.83,0c0.7,0.01,1.04,0.34,1.04,1.04c0,0.8,0,1.61,0,2.41
		c0,0.61-0.33,0.98-0.94,0.99c-0.96,0.02-1.92,0.02-2.88,0C9.82,9.19,9.46,8.84,9.46,8.29c0.01-1.26-0.01-2.51,0.07-3.77
		C9.6,3.38,10,2.34,10.95,1.6c0.54-0.43,1.17-0.66,1.85-0.75C12.87,0.84,12.93,0.82,13,0.8C13.17,0.8,13.33,0.8,13.5,0.8z
		 M12.73,2.03c-0.47,0.08-0.86,0.27-1.19,0.57c-0.62,0.57-0.85,1.32-0.89,2.11c-0.06,1.03-0.03,2.07-0.04,3.1
		c0,0.17,0.05,0.25,0.24,0.24c0.67-0.01,1.35-0.01,2.02,0c0.17,0,0.23-0.06,0.23-0.22c-0.01-0.56-0.01-1.13,0-1.69
		c0-0.19-0.08-0.23-0.25-0.23c-0.34,0.01-0.68,0.01-1.03,0c-0.43-0.01-0.66-0.26-0.66-0.69c0-0.19,0.02-0.39,0.05-0.58
		c0.12-0.84,0.42-1.59,1.24-1.97C12.77,2.53,12.81,2.35,12.73,2.03z"/>
			<path class="st0" d="M7.84,0.8c0.31,0.18,0.4,0.44,0.39,0.79c-0.02,0.45,0,0.91-0.01,1.36c0,0.36-0.17,0.55-0.51,0.62
		c-0.7,0.14-0.96,0.44-1.03,1.2c0.28,0,0.55,0,0.83,0c0.7,0.01,1.03,0.35,1.04,1.05c0,0.79,0,1.57,0,2.36
		c0,0.69-0.35,1.04-1.04,1.04c-0.9,0.01-1.79,0.01-2.69,0c-0.7,0-1.03-0.34-1.03-1.04c0-1.05-0.02-2.11,0.01-3.16
		C3.84,4,4.05,3.03,4.68,2.2c0.6-0.8,1.43-1.19,2.4-1.35C7.17,0.84,7.26,0.82,7.34,0.8C7.51,0.8,7.68,0.8,7.84,0.8z M4.92,8.05
		c0.79,0,1.54,0,2.29,0c0.18,0,0.18-0.1,0.18-0.23c0-0.55-0.01-1.11,0-1.66c0-0.2-0.07-0.25-0.26-0.25c-0.33,0.01-0.67,0.01-1,0
		C5.72,5.9,5.49,5.66,5.5,5.25C5.5,5,5.52,4.75,5.56,4.5C5.7,3.7,6.03,3.03,6.8,2.65c0.33-0.16,0.35-0.21,0.25-0.61
		c-0.05,0-0.1,0-0.16,0.01C5.88,2.31,5.15,3.12,5.04,4.29c-0.1,1.05-0.09,2.12-0.12,3.18C4.91,7.65,4.92,7.83,4.92,8.05z"/>
			<path class="st0" d="M14.99,11.76c-2.18,0-4.36,0-6.54,0c-0.14,0-0.28-0.01-0.41-0.04c-0.24-0.05-0.41-0.27-0.42-0.52
		c0-0.26,0.17-0.48,0.43-0.54c0.13-0.02,0.26-0.03,0.38-0.03c4.38,0,8.76,0,13.14,0c0.13,0,0.26,0.01,0.38,0.03
		c0.24,0.05,0.41,0.27,0.42,0.52c0,0.26-0.17,0.49-0.43,0.54c-0.13,0.03-0.27,0.03-0.41,0.03C19.36,11.76,17.17,11.76,14.99,11.76z"
			/>
			<path class="st0" d="M15,13.61c2.19,0,4.38,0,6.57,0c0.1,0,0.2,0,0.3,0.01c0.27,0.03,0.48,0.24,0.5,0.51
		c0.02,0.26-0.14,0.49-0.4,0.56c-0.1,0.03-0.22,0.04-0.33,0.04c-4.44,0-8.87,0-13.31,0c-0.54,0-0.85-0.36-0.68-0.77
		c0.12-0.28,0.35-0.35,0.63-0.35c1.45,0,2.9,0,4.35,0C13.43,13.61,14.21,13.61,15,13.61z"/>
			<path class="st0" d="M15,17.67c-2.19,0-4.38,0-6.57,0c-0.1,0-0.2,0-0.3-0.01c-0.27-0.03-0.48-0.24-0.5-0.51
		c-0.02-0.25,0.14-0.49,0.4-0.56c0.1-0.03,0.22-0.04,0.33-0.04c4.44,0,8.87,0,13.31-0.01c0.63,0,0.85,0.5,0.66,0.82
		c-0.14,0.24-0.35,0.3-0.61,0.3c-1.8,0-3.6,0-5.41,0C15.87,17.67,15.43,17.67,15,17.67z"/>
			<path class="st0" d="M18.2,19.51c1.12,0,2.24,0,3.35,0c0.14,0,0.28,0.01,0.41,0.04c0.24,0.05,0.41,0.28,0.41,0.52
		c0,0.25-0.17,0.47-0.41,0.53c-0.12,0.03-0.26,0.04-0.38,0.04c-2.26,0-4.53,0-6.79,0c-0.13,0-0.26-0.01-0.38-0.04
		C14.17,20.55,14,20.33,14,20.08c0-0.25,0.16-0.48,0.41-0.53c0.13-0.03,0.27-0.04,0.41-0.04C15.95,19.51,17.07,19.51,18.2,19.51z"/>
			<path class="st0" d="M16.22,5.12c0.3,0,0.55,0.24,0.55,0.54c0,0.3-0.27,0.58-0.57,0.57c-0.29-0.01-0.54-0.28-0.54-0.56
		C15.67,5.37,15.92,5.13,16.22,5.12z"/>
			<path class="st0" d="M11.42,20.63c-0.3,0-0.55-0.24-0.55-0.54c-0.01-0.31,0.25-0.56,0.56-0.56c0.3,0,0.55,0.24,0.55,0.54
		C11.99,20.37,11.73,20.63,11.42,20.63z"/>
		</g>

	</Icon>
);

export default PCTestimonialIcon;
